import React from 'react';
import { motion } from 'framer-motion';
export function Booking() {
  return <section id="turnos" className="py-24 bg-brand-mocha text-white relative overflow-hidden" data-id="element-44">
      {/* Subtle background pattern/glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-brand-rose/5 blur-[100px] pointer-events-none" data-id="element-45" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-46">
        <div className="text-center max-w-3xl mx-auto" data-id="element-47">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif mb-6 text-brand-cream" data-id="element-48">
            Agendá tu Turno
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-brand-cream/70 mb-16" data-id="element-49">
            Reservar tu momento de cuidado personal es muy fácil. Seguí estos
            pasos y asegurá tu lugar.
          </motion.p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-50">
            {/* Step 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="flex flex-col items-center" data-id="element-51">
              <div className="w-16 h-16 rounded-full border border-brand-gold/30 flex items-center justify-center text-2xl font-serif text-brand-gold mb-4 relative" data-id="element-52">
                1
                <div className="hidden md:block absolute top-1/2 left-full w-full h-[1px] bg-brand-gold/20 -translate-y-1/2 ml-4" data-id="element-53" />
              </div>
              <h3 className="text-lg font-medium text-brand-cream mb-2" data-id="element-54">
                Elegí servicio
              </h3>
              <p className="text-sm text-brand-cream/60 text-center" data-id="element-55">
                Seleccioná el tratamiento que deseás realizarte.
              </p>
            </motion.div>

            {/* Step 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="flex flex-col items-center" data-id="element-56">
              <div className="w-16 h-16 rounded-full border border-brand-gold/30 flex items-center justify-center text-2xl font-serif text-brand-gold mb-4 relative" data-id="element-57">
                2
                <div className="hidden md:block absolute top-1/2 left-full w-full h-[1px] bg-brand-gold/20 -translate-y-1/2 ml-4" data-id="element-58" />
              </div>
              <h3 className="text-lg font-medium text-brand-cream mb-2" data-id="element-59">
                Elegí fecha
              </h3>
              <p className="text-sm text-brand-cream/60 text-center" data-id="element-60">
                Buscá el día y horario que mejor se adapte a vos.
              </p>
            </motion.div>

            {/* Step 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.5
          }} className="flex flex-col items-center" data-id="element-61">
              <div className="w-16 h-16 rounded-full border border-brand-gold/30 flex items-center justify-center text-2xl font-serif text-brand-gold mb-4" data-id="element-62">
                3
              </div>
              <h3 className="text-lg font-medium text-brand-cream mb-2" data-id="element-63">
                Confirmá
              </h3>
              <p className="text-sm text-brand-cream/60 text-center" data-id="element-64">
                Completá tus datos y listo, ¡te esperamos!
              </p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} data-id="element-65">
            <a href="https://cfstudio.koob.uy" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 bg-brand-rose text-white rounded-full font-medium text-lg transition-all hover:bg-brand-rose/90 hover:shadow-lg hover:-translate-y-1" data-id="element-66">
              Ir a la agenda virtual
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}